var env = require("../utils/env");
var mediaAPI = env.domain.mediaApi;
var api = env.domain.api;
var request = require('superagent');

function urltoFile(url, filename, mimeType, callback){
    return (fetch(url)
        .then(function(res) {
            return res.arrayBuffer()
        })
        .then(function(buf) {
            callback(new File([buf], filename, {type:mimeType}))
        })
    );
}


exports.requestPermission = function(file, callback) {
    callback = callback || function(){};
    var name = file.name || '';
    request
    .post(api + "/v1/media/s3_sign_request")
    .withCredentials()
    .send({
        "contentType": file.type,
        "fileName": name.replace(/[^a-z0-9-_\.]/gi, '_').toLowerCase()
    })
    .then(function(res) {
        return callback(null, res.body);
    }, function(err) {
        return callback(err);
    })
}

exports.uploadFileS3 = function(options, callback) {
    callback = callback || function(){};
    exports.requestPermission(options, function(err, permission) {
        if (err) return callback(err);
        urltoFile(options.data, options.name, options.type, function(file) {
            request
            .put(permission.signed_request)
            .send(file)
            .then(function(response) {
                return callback(null, permission);
            }, function(error) {
                return callback(error);
            })
        });
    })
}

exports.uploadFile = function(file, callback) {
    callback = callback || function(){};
    console.log(file);
    exports.requestPermission(file, function(err, permission) {
        if (err) return callback(err);
        request
        .put(permission.signed_request)
        .send(file)
        .then(function(response) {
            return callback(null, permission);
        }, function(error) {
            return callback(error);
        })
    })
}


/** WEBPACK FOOTER **
 ** ./src/resources/media.js
 **/